import { BrokeredOrderValidationResult } from '../types/brokeredOrder';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const brokeredOrderValidateQueryAtom = createQueryAtomFactory(
  'brokerage.brokeredOrderValidate',
  (params: { id: string }) => ({
    tradeBrokeredOrderValidate: {
      __args: {
        id: params.id,
      },
      valid: true,
      errors: {
        code: true,
        message: true,
        itemId: true,
      },
    },
  }),
  {
    select: (data): BrokeredOrderValidationResult => {
      const result = data.tradeBrokeredOrderValidate;
      return {
        valid: result.valid,
        errors: (result.errors ?? []).map((error) => ({
          code: error.code,
          message: error.message,
          itemId: error.itemId ?? null,
        })),
      };
    },
  },
);
